<template>
  <div id='deliverable'>
    Hello:<br>
    <br>
    <span v-html='estimate.deliverable'></span><br>

    <strong>Services Included:</strong>
    <ol>
      <li v-for='l in sortedLines' :key='l.id'>
        <strong>{{ l.description }}</strong><br>
        <span v-html='l.notes'></span>
      </li>
    </ol>
    <br>
    <div v-if='options'>
      <strong>Optional Services:</strong>
      <ol>
        <li v-for='o in sortedOptions' :key='o.id'>
          <strong>{{ o.description }}</strong><br>
          <span v-html='o.notes'></span>
        </li>
      </ol>
      <br>
    </div>
    <span v-if='estimate.customer_notes'>
      <strong>Notes:</strong><br>
      <span v-html='estimate.customer_notes'></span>
      <br>
    </span>

    <strong>Quote: {{ estimate.amount | decMoney }} / month</strong><br>
    <br>
    Our season runs from {{ estimate.division_obj.season_starts | dateNoYear }} until {{ estimate.division_obj.season_ends | dateNoYear }}.<br>
    <br>
    Let me know if you have any questions.<br>
    <br>
    Talk soon!<br>
    <br>
    {{ estimator }}<br>
    <small><strong>{{ estimate.division_obj.company_name }}</strong></small>
    <br>
  </div>
</template>

<script>
import misc from '@/services/misc'

export default {
  name: 'estimate-deliverable-preview',
  props: {
    estimate: {
      required: true
    },
    lines: {
      required: true
    },
    options: {
      required: false
    },
    isTemplate: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: true,
    settings: {}

  }),
  computed: {
    sortedLines () {
      return misc.sortLineItems(this.lines)
    },
    sortedOptions () {
      return misc.sortLineItems(this.options)
    },
    estimator () {
      if (this.isTemplate) {
        return '[Estimator]'
      } else {
        if (this.estimate.estimator) {
          return this.estimate.estimator_obj.name_display
        } else {
          return '(n/a)'
        }
      }
    }
  }
}
</script>
